import React, { useState, useEffect, useRef } from "react";
import {
  FaEllipsisH,
  FaExclamationCircle,
  FaSearch,
  FaTimes,
} from "react-icons/fa";
import Cards from "../../components/AdminSideComponents/Cards";
import bedsLogo from "../../Assets/Logos/BedsLogo.png";
import InmatesLogo from "../../Assets/Logos/InmatesLogo.png";
import bedsOccupied from "../../Assets/Logos/bedsOccupied.png";
import noticesLogo from "../../Assets/Logos/noticesLogo.png";
import { useNavigate } from "react-router-dom";
import { MdAddCircle } from "react-icons/md";
import axios from "axios";
import toast from "react-hot-toast";

import deleteIcon from "../../Assets/Logos/checkout/deleteIcon.png";
import editIcon from "../../Assets/Logos/checkout/editIcon.png";
import goToProfileIcon from "../../Assets/Logos/checkout/goToProfileIcon.png";
import eVerifyIcon from "../../Assets/Logos/checkout/eVerifyIcon.png";
import GiveNotice from "../../components/AdminSideComponents/GiveNotice";
import checkoutIcon from "../../Assets/Logos/checkout/checkoutIcon.png";
import giveNoticeIcon from "../../Assets/Logos/checkout/giveNoticeIcon.png";
import updatePaymentIcon from "../../Assets/Logos/checkout/updatePaymentIcon.png";
import CheckOutModal from "../../components/AdminSideComponents/CheckOutModal";
import CreatePaymentRecord from "../../components/AdminSideComponents/CreatePaymentRecord";

import PaymentDetailsView from "../../components/AdminSideComponents/PaymentDetailsView";
import DeleteConfirmationModal from "../../components/AdminSideComponents/DeleteConfirmationModal";
import { formatDate } from "../../utils/dateFormat";
import AddFineModal from "../../components/AdminSideComponents/AddFineModal";

const Checkin = () => {
  const [showDropdown, setShowDropdown] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [checkIns, setCheckins] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadNoticeModal, setLoadNoticeModal] = useState(false);
  const [currentCheckIn, setCurrentCheckIn] = useState({});
  const [loadPaymentModal, setLoadPaymentModal] = useState(false);
  const [loadFineModal, setLoadFineModal] = useState(false);

  const [isModalOpen, setModalOpen] = useState(false);
  const [removeNoticeModalOpen, setRemoveNoticeModalOpen] = useState(false);
  const [bedCounts, setBedCounts] = useState({});
  const navigate = useNavigate();
  console.log("Pagination", pagination);
  const itemsPerPage = 10;
  const dropdownRefs = useRef([]);

  const [dropdownPosition, setDropdownPosition] = useState("down");

  const toggleDropdown = (index) => {
    // Get the position of the dropdown element to determine where it should open
    const dropdownElement = dropdownRefs.current[index];
    if (dropdownElement) {
      const rect = dropdownElement.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      console.log("myValues :", spaceBelow, spaceAbove);
      console.log("myElement", rect);
      // Set dropdown position based on available space
      if (spaceBelow < 200 && spaceAbove > 150) {
        setDropdownPosition("up");
      } else {
        setDropdownPosition("down");
      }
    }

    // Toggle the dropdown visibility, close it if already open
    setShowDropdown((prev) => (prev === index ? null : index));
  };

  const closeDropdownOnOutsideClick = (event) => {
    if (
      !dropdownRefs.current.some((ref) => ref && ref.contains(event.target))
    ) {
      setShowDropdown(null); // Close any open dropdowns
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdownOnOutsideClick);
    return () => {
      document.removeEventListener("click", closeDropdownOnOutsideClick);
    };
  }, []);

  const items = [
    {
      name: "Total Check In",
      numberOfItems: pagination?.totalCheckIns || 0,
      icon: InmatesLogo,
    },
    {
      name: "Number Of Beds Vacant",
      numberOfItems: bedCounts?.totalVacantBeds || 0,
      icon: bedsLogo,
    },
    {
      name: "Number Of Beds Occupied",
      numberOfItems: bedCounts?.totalOccupiedBeds || 0,
      icon: bedsOccupied,
    },
    {
      name: "Number Of Notices",
      numberOfItems: bedCounts?.bedsOnNotice || 0,
      icon: noticesLogo,
    },
  ];

  const getBedCounts = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/beds/get_bed_counts`,
      headers: {},
    };
    axios
      .request(config)
      .then((response) => {
        console.log("Response of getBedCounts: ", response.data.data);
        setBedCounts(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getBedCounts();
  }, []);

  const getAllCheckIns = (page) => {
    setLoading(true);
    const tenantStatus = "Check In";
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/get_check_in_paginated?page=${page}&limit=${itemsPerPage}&search=${searchQuery}&tenantStatus=${tenantStatus}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("------>", response.data);
        setCheckins(response.data.data);
        setLoading(false);
        setPagination(response.data.pagination);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  console.log("Pagination: ", pagination);
  useEffect(() => {
    const timeout = setTimeout(() => {
      getAllCheckIns(currentPage);
    }, 800); // Waits for 800ms of inactivity
    return () => clearTimeout(timeout);
  }, [currentPage, searchQuery, loadNoticeModal]);

  const deleteCheckIn = (id) => {
    if (window.confirm("Are you sure you want to delete this item ?")) {
      let config = {
        method: "delete",
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_API_URL}/check_in/delete_check_in/${id}`,
        headers: {},
      };

      axios
        .request(config)
        .then((response) => {
          console.log(response.data);
          getAllCheckIns(currentPage);
          toast.success(response.data.message);
          setShowDropdown(null);
        })
        .catch((error) => {
          console.log(error);
          toast.success(error.response.data.message);
        });
    }
  };

  const handleUpdatePaymentClick = (checkin) => {
    setLoadPaymentModal(true);
    setCurrentCheckIn(checkin);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showDropdown !== null &&
        dropdownRefs.current[showDropdown] &&
        !dropdownRefs.current[showDropdown].contains(event.target)
      ) {
        setShowDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  return (
    <div className="checkinContainer p-6 bg-primarybgColor ">
      {loadPaymentModal ? (
        <PaymentDetailsView
          setLoadPaymentModal={setLoadPaymentModal}
          currentCheckIn={currentCheckIn}
          getAllCheckIn={getAllCheckIns}
        />
      ) : (
        ""
      )}

      {loadNoticeModal && (
        <GiveNotice
          setLoadNoticeModal={setLoadNoticeModal}
          currentCheckIn={currentCheckIn}
        />
      )}

      <DeleteConfirmationModal
        isOpen={removeNoticeModalOpen}
        onClose={() => setRemoveNoticeModalOpen(false)}
        currentCheckIn={currentCheckIn}
        getAllNotice={getAllCheckIns}
      />

      <CheckOutModal
        isOpen={isModalOpen}
        currentCheckIn={currentCheckIn}
        onClose={() => setModalOpen(false)}
      />

      {loadFineModal && (
        <AddFineModal
          checkin={currentCheckIn}
          onClose={() => setLoadFineModal(false)}
        />
      )}
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Check In
      </h1>
      <Cards items={items} />

      <div className="p-4 bg-white shadow-lg mt-6 rounded-lg ">
        <div className="flex justify-between items-center mb-4 flex-col md:flex-row">
          <h1 className="text-[18px] mb-2 lg:mt-0 text-primaryTextColor sm:text-[24px] font-bold">
            Check In List
          </h1>

          <div className="relative flex items-center gap-1 lg:gap-2">
            <div className="relative ">
              <input
                type="text"
                placeholder="Search..."
                className="border w-[100%] lg:w-auto border-gray-300 rounded-lg p-2 pl-8 pr-10 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                value={searchQuery}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchQuery(e.target.value);
                }}
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-secondaryTextColor" />

              {searchQuery && (
                <FaTimes
                  onClick={clearSearch}
                  className="absolute right-3 top-3 text-secondaryTextColor cursor-pointer"
                />
              )}
            </div>
            <MdAddCircle
              onClick={() => navigate("/create_checkin")}
              className="rounded-lg cursor-pointer text-primaryColor"
              size={40}
            />
          </div>
        </div>
        <div className="overflow-x-auto   min-h-[70vh]">
          <table className="min-w-full overflow-y-visible bg-white  border-gray-200 rounded-md">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl ">
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Name
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Mobile No / Email
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Building Name
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Room No
                </th>
                {/* <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                Bed No
              </th> */}

                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Booking Amount
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Security Deposit
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor">
                  Joining Date
                </th>
                <th className="py-3 px-6 text-left text-[14px] font-semibold text-primaryTextColor rounded-r-xl ">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="font-medium text-[13px] text-[#202224] tracking-wide">
              {loading ? (
                // Skeleton Loader
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 bg-gray-300 rounded w-1/4"></div>
                    </td>
                  </tr>
                ))
              ) : checkIns?.length > 0 ? (
                checkIns.map((booking, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 px-6 relative flex flex-col text-sm text-primaryTextColor">
                      {booking.name}
                      {booking?.notice?.UnderNotice && (
                        <span className="text-xs absolute right-0 -bottom-2 rounded-md w-fit px-2 py-1 text-right bg-yellow-200">
                          {booking?.notice?.UnderNotice && "On Notice"}
                        </span>
                      )}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.mobile}
                      <br />
                      <span className="text-secondaryTextColor">
                        {booking.email}
                      </span>
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.hostelName.nameBuilding}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      R-F{booking.roomId.floorNumber}
                      {String(booking.roomId.roomNumber).padStart(3, "0")}
                    </td>
                    {/* <td className="py-4 px-6 text-sm text-primaryTextColor">
                  {booking.BedNo}
                </td> */}

                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.bookingAmount}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {booking.securityDeposit}
                    </td>
                    <td className="py-4 px-6 text-sm text-primaryTextColor">
                      {formatDate(booking.joiningDate)}
                    </td>
                    <td className="py-4 px-6  text-sm hover:text-primaryTextColor text-secondaryTextColor  mt-4 relative ">
                      <div
                        className="relative "
                        ref={(el) => (dropdownRefs.current[index] = el)}
                      >
                        <FaEllipsisH
                          size={25}
                          className="cursor-pointer"
                          onClick={() => toggleDropdown(index)}
                        />
                        {showDropdown === index && (
                          <div
                            className={`absolute right-0 w-48 md:w-96 bg-white border border-gray-200 rounded-md shadow-lg z-50`}
                          >
                            <ul className="grid grid-cols-1 md:grid-cols-2 gap-2 py-2 ">
                              <li
                                onClick={() => {
                                  navigate(`/profile/${booking._id}`);
                                  setShowDropdown(null);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={goToProfileIcon}
                                  className="h-4 w-4"
                                  alt="Go to Profile"
                                />
                                Go to Profile
                              </li>
                              <li className="text-gray-900 flex items-center gap-2 hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm">
                                <img
                                  src={eVerifyIcon}
                                  className="h-4 w-4"
                                  alt="E-Verify Adhaar"
                                />
                                E-Verify Adhaar
                              </li>

                              <li
                                className="text-gray-900 flex items-center gap-2 hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                                onClick={() => {
                                  handleUpdatePaymentClick(booking);
                                  setShowDropdown(null);
                                }}
                              >
                                <img
                                  src={updatePaymentIcon}
                                  alt=""
                                  className="h-4 w-4"
                                />
                                Update Payment
                              </li>

                              {!booking?.notice?.UnderNotice ? (
                                <li
                                  onClick={() => {
                                    setLoadNoticeModal(true);
                                    setCurrentCheckIn(booking);
                                    setShowDropdown(null);
                                  }}
                                  className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                                >
                                  <img
                                    src={giveNoticeIcon}
                                    className="h-4 w-4"
                                    alt="Give Notice"
                                  />
                                  Give Notice
                                </li>
                              ) : (
                                <li
                                  onClick={() => {
                                    setCurrentCheckIn(booking);
                                    setShowDropdown(null);
                                    setRemoveNoticeModalOpen(true);
                                  }}
                                  className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                                >
                                  <img
                                    src={giveNoticeIcon}
                                    className="h-4 w-4"
                                    alt="Remove Notice"
                                  />
                                  Remove Notice
                                </li>
                              )}
                              <li
                                onClick={() => {
                                  setModalOpen(true);
                                  setShowDropdown(null);
                                  setCurrentCheckIn(booking);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={checkoutIcon}
                                  className="h-4 w-4"
                                  alt="checkout"
                                />{" "}
                                Check Out
                              </li>

                              <li
                                onClick={() => {
                                  navigate(
                                    `/edit_checkin?itemId=${booking._id}&floor_no=${booking.floorNo}`
                                  );
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={editIcon}
                                  className="h-4 w-4"
                                  alt="Edit"
                                />
                                Edit
                              </li>
                              <li
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                                onClick={() => {
                                  setLoadFineModal(true);
                                  setShowDropdown(null);
                                  setCurrentCheckIn(booking);
                                }}
                              >
                                <FaExclamationCircle color="red" />
                                Add Fine
                              </li>
                              <li
                                onClick={() => {
                                  deleteCheckIn(booking._id);
                                }}
                                className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                              >
                                <img
                                  src={deleteIcon}
                                  className="h-4 w-4"
                                  alt="Delete"
                                />
                                Delete
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="8"
                    className="py-40 px-6 text-lg text-center text-secondaryTextColor"
                  >
                    No CheckIn available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(itemsPerPage * currentPage, pagination.totalCheckIns)} of{" "}
            {pagination.totalCheckIns}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === pagination.totalPages
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === pagination.totalPages}
            >
              →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkin;
